/**
 * UM Alerts tab entry point.
 *
 * TEMP: reuses CDI Alerts UI + endpoints (including AI-logo tab parity).
 * Replace this implementation when UM Alerts has its own API/UI.
 */
import CDI from "../../CDI";

const UmAlerts = CDI;

export default UmAlerts;
